/* Opinie klientek (Anna & Klara) — render wspólnej puli opinii z assets/opinie.json.
   Miniatury/linki z mapy produktów wstrzykniętej serwerowo (dynamiczne).
   Bez zależności, bez frameworków. */
(function () {
  var STAR = 'M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.2 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z';

  function stars(n) {
    var s = '<span class="ak-op__stars" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      s += '<svg viewBox="0 0 24 24" class="ak-op__star--' + (i <= n ? 'on' : 'off') + '"><path d="' + STAR + '"/></svg>';
    }
    return s + '</span>';
  }

  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function card(r, products) {
    var art = el('article', 'ak-op__card');
    art.setAttribute('role', 'listitem');

    var st = el('div');
    st.innerHTML = stars(r.ocena);
    art.appendChild(st.firstChild);

    if (r.tytul) { var h = el('h3', 'ak-op__title'); h.textContent = r.tytul; art.appendChild(h); }
    if (r.tresc) { var p = el('p', 'ak-op__body'); p.textContent = r.tresc; art.appendChild(p); }

    var prod = products[r.handle] || null;
    var sigText = [r.imie, r.miasto, r.produkt].filter(Boolean).join(' · ');
    var sig;
    if (prod && prod.url) {
      sig = el('a', 'ak-op__sig');
      sig.href = prod.url;
    } else {
      sig = el('div', 'ak-op__sig');
    }
    if (prod && prod.img) {
      var img = el('img', 'ak-op__thumb');
      img.src = prod.img;
      img.width = 48; img.height = 48;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = r.produkt || '';
      sig.appendChild(img);
    }
    var nm = el('span', 'ak-op__signame');
    nm.textContent = sigText;
    sig.appendChild(nm);
    art.appendChild(sig);
    return art;
  }

  function render(root, reviews) {
    var products = {};
    var pscript = root.querySelector('.ak-op__products');
    if (pscript) { try { products = JSON.parse(pscript.textContent); } catch (e) { products = {}; } }

    var total = reviews.length;
    if (!total) { root.hidden = true; return; }
    var visible = parseInt(root.getAttribute('data-visible'), 10) || 6;

    // Średnia i rozkład
    var sum = 0, dist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    reviews.forEach(function (r) { sum += r.ocena; if (dist[r.ocena] != null) dist[r.ocena]++; });
    var avg = sum / total;

    var summary = root.querySelector('[data-ak-summary]');
    if (summary) {
      var avgEl = summary.querySelector('[data-ak-avg]');
      if (avgEl) avgEl.innerHTML = avg.toFixed(1).replace('.', ',') + '<small>&nbsp;/&nbsp;5</small>';
      var avgStars = summary.querySelector('[data-ak-avgstars]');
      if (avgStars) {
        var pct = (avg / 5 * 100).toFixed(2);
        var five = '';
        for (var s = 0; s < 5; s++) five += '<svg viewBox="0 0 24 24"><path d="' + STAR + '"/></svg>';
        avgStars.classList.add('ak-op__ratebar');
        avgStars.innerHTML = '<span class="ak-op__ratebar-track">' + five + '</span>'
                           + '<span class="ak-op__ratebar-fill" style="width:' + pct + '%">' + five + '</span>';
        avgStars.setAttribute('role', 'img');
        avgStars.setAttribute('aria-label', 'Średnia ocena ' + avg.toFixed(1).replace('.', ',') + ' na 5');
      }
      var cnt = summary.querySelector('[data-ak-count]');
      if (cnt) cnt.textContent = total + ' ' + plural(total, 'opinia', 'opinie', 'opinii');
      var distWrap = summary.querySelector('[data-ak-dist]');
      if (distWrap) {
        var html = '';
        [5, 4, 3, 2, 1].forEach(function (k) {
          var pct = total ? Math.round((dist[k] / total) * 100) : 0;
          html += '<div class="ak-op__dist-row"><span>' + k + '★</span>'
                + '<span class="ak-op__dist-bar"><span class="ak-op__dist-fill" style="width:' + pct + '%"></span></span>'
                + '<span>' + dist[k] + '</span></div>';
        });
        distWrap.innerHTML = html;
      }
      summary.hidden = false;
    }

    // Karty
    var grid = root.querySelector('[data-ak-grid]');
    grid.setAttribute('role', 'list');
    var frag = document.createDocumentFragment();
    reviews.forEach(function (r, i) {
      var c = card(r, products);
      if (i >= visible) c.classList.add('is-extra');
      frag.appendChild(c);
    });
    grid.innerHTML = '';
    grid.appendChild(frag);

    // Przycisk rozwijania
    var btn = root.querySelector('[data-ak-toggle]');
    if (btn && total > visible) {
      var labelMore = 'Zobacz wszystkie opinie (' + total + ')';
      var labelLess = 'Zwiń opinie';
      btn.textContent = labelMore;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = root.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? labelLess : labelMore;
      });
    }
  }

  function plural(n, one, few, many) {
    var m10 = n % 10, m100 = n % 100;
    if (n === 1) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
    return many;
  }

  function init(root) {
    if (root.hasAttribute('data-ak-done')) return;
    root.setAttribute('data-ak-done', '1');
    var src = root.getAttribute('data-src');
    if (!src) return;
    fetch(src, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(root, Array.isArray(data) ? data : []); })
      .catch(function () { root.hidden = true; });
  }

  function boot() {
    document.querySelectorAll('[data-ak-opinie]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
